import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface LookupDto {
      id: string;
      code: string;
      name: string;
}
@Injectable({
      providedIn: 'root'
})
export class ModuleService {
      private readonly apiUrl = `${environment.apiUrl}/api/MetaEntities`;

      constructor(private http: HttpClient) { }

      getModules(): Observable<LookupDto[]> {
            return this.http.get<LookupDto[]>(`${this.apiUrl}/modules`);
      }

      getEntitiesByModule(moduleCode: string): Observable<LookupDto[]> {
            return this.http.get<LookupDto[]>(`${this.apiUrl}/entities/${moduleCode}`);
      }
}